import { render, staticRenderFns } from "./ProgramaRecompensaAjusteSaldo.vue?vue&type=template&id=fbf1bc72&scoped=true&"
import script from "./ProgramaRecompensaAjusteSaldo.vue?vue&type=script&lang=js&"
export * from "./ProgramaRecompensaAjusteSaldo.vue?vue&type=script&lang=js&"
import style0 from "./ProgramaRecompensaAjusteSaldo.vue?vue&type=style&index=0&id=fbf1bc72&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fbf1bc72",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VBtnToggle } from 'vuetify/lib/components/VBtnToggle';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VBtnToggle,VDivider,VIcon})
